export default "images/img-finder-2.jpg";